import React, { Component } from 'react';
import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  withStyles,
  Tooltip
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNew from '@material-ui/icons/OpenInNew';
import CustomExpansionPanel from '../../commons/components/CustomExpansionPanel';
import styles from './styles/ResultListStyles';
import ExpansionStyleContext from '../contexts/ExpansionStyleContext';

const Transition = (props) => <Slide direction="up" {...props} />;

class ResultList extends Component {
  handleClose = () => {
    this.props.handleClose();
  }

  openVehicleInfoOnTrix = (result) => {
    let tomorrowsDate = new Date(result.createdDate);
    tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);
    tomorrowsDate = this.getFormattedDate(tomorrowsDate);
    window.open(
      `https://trix2.trixlog.com/#/vehicle/details/${result.vehicle.id}//${result.createdDate}T03:00:00.000Z/${tomorrowsDate}T02:59:59.999Z`,
      '_blank'
    );
  }

  getFormattedDate = (date) => {
    return date.toISOString().substr(0, 10);
  }

  render() {
    const { classes, open, result } = this.props;
    return (
      <div>
        {result && <Dialog
          fullScreen
          open={open}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
              <Typography variant="title" color="inherit" className={classes.flex}>
                Valores Calculados das Coordenadas {result ? 'do dia ' + new Date(result.createdDate).toISOString('pt').substr(0, 10).split('-').reverse().join('/') + ' - Serial: ' + result.serial : ''}
              </Typography>
              <div>
                <Tooltip id="tooltip-top" title="Ver no Trix" placement="top">
                    <div>
                      <IconButton
                        disabled={!result.vehicle || !result.vehicle.id}
                        color="inherit"
                        onClick={() => this.openVehicleInfoOnTrix(result)}
                      >
                        <OpenInNew />
                      </IconButton>
                    </div>
                </Tooltip>
              </div>
            </Toolbar>
          </AppBar>
          {/* Total de Coordenadas Analisadas */}
          <ExpansionStyleContext.Provider value={classes}>
            <CustomExpansionPanel title="Coordenadas Analisadas" shouldRender={result.coordinatesAmount >= 0} 
              render={() => (
                <Typography color="primary">
                  Quantidade: {result.coordinatesAmount} <br/>
                  Data da última coordenada: {new Date(result.lastCoordinate.coordinate.coordinateDate).toLocaleDateString('pt')} {new Date(result.lastCoordinate.coordinate.coordinateDate).toLocaleTimeString('pt')}
                </Typography>
              )}
            />
            {/* Distância levando em conta Latitude Longitude */}
            <CustomExpansionPanel title="Distância de Latitude Longitude" shouldRender={result.latLngDistance >= 0} 
              render={() => (
                <Typography color="primary">
                  {(result.latLngDistance / 1000).toFixed(2)} km
                </Typography>
              )}
            />
            {/* Distância de Hodômetro */}
            <CustomExpansionPanel title="Distância de Hodômetro" shouldRender={result.hodometerDistance >= 0} 
              render={() => (
                <Typography color="primary">
                  {(result.hodometerDistance / 1000).toFixed(2)} km
                </Typography>
              )}
            />
            {/* Média da Velocidade */}
            <CustomExpansionPanel title="Velocidade Média" shouldRender={result.meanSpeed >= 0} 
              render={() => (
                <Typography color="primary">
                  {result.meanSpeed.toFixed(2)} km/h
                </Typography>
              )}
            />
            {/* Velocidade Máxima */}
            <CustomExpansionPanel title="Velocidade Máxima" shouldRender={result.maxSpeed >= 0}  
              render={() => (
                <Typography color="primary">
                  {result.maxSpeed.toFixed(2)} km/h
                </Typography>
              )}
            />
            {/* Equipamento Informações PULS */}
            <CustomExpansionPanel title="Informações PULS" shouldRender={result.equipmentInfo} 
              render={() => (
                <Typography color="primary">
                  Config Group: {result.equipmentInfo.configGroup} <br/>
                  Config Status: {result.equipmentInfo.configStatus} <br/>
                  {result.equipmentInfo.lastConfigUpdateTime ? `Última Atualização da Config: ${result.equipmentInfo.lastConfigUpdateTime.split('-').reverse().join('/')}` : null} <br/>
                  Versão do Firmware: {result.equipmentInfo.firmwareVersion ? result.equipmentInfo.firmwareVersion : null}
                </Typography>
              )}
            />
            {/* Equipamento Informações GM */}
            <CustomExpansionPanel title="Informações de Rota do GM" shouldRender={result.gmRouteInfos && result.gmRouteInfos.length >= 1} 
              render={() => (
                result.gmRouteInfos.map((routeInfo, key) => 
                  <div key={key} style={{paddingRight: '30px'}}>
                    <Typography color="primary">
                      Motorista: {routeInfo.primaryAssignments.driver.name} <br/>
                      {routeInfo.route.actualDistance ? `Distância percorrida: ${(routeInfo.route.actualDistance / 1000).toFixed(2)} km` : ''} <br/>
                      {routeInfo.route.key ? `Key: ${routeInfo.route.key}` : ''} <br/>
                    </Typography>
                  </div>
                )
              )}
            />
            {/* Média de Satélites */}
            <CustomExpansionPanel title="Média de Satélites" shouldRender={result.meanSatellitesInView >= 0} 
              render={() => (
                <Typography color="primary">
                  {result.meanSatellitesInView.toFixed(2)}
                </Typography>
              )}
            />
            {/* Média de HDOP */}
            <CustomExpansionPanel title="Média de HDOP" shouldRender={result.meanHdop >= 0} 
              render={() => (
                <Typography color="primary">
                  {result.meanHdop.toFixed(2)}
                </Typography>
              )}
            />
            {/* Contador de Razao de Transmissao */}
            <CustomExpansionPanel title="Razões de Transmissão" shouldRender={result.transmissionReasonAmount} 
              render={() => (
                <Typography color="primary">
                  {Object.keys(result.transmissionReasonAmount).map((transmissionReason, key) => 
                    <span key={key}>
                      {'ID Transmissão: ' + transmissionReason + ', Total: ' + result.transmissionReasonAmount[transmissionReason]}<br />
                    </span>
                  )}
                </Typography>
              )}
            />
            {/* Acumuladores: RPM, Velocidade, RPM */}
            <CustomExpansionPanel title="Quantidade de Acumuladores com Valores Topados" shouldRender={true} 
              render={() => (
                <Typography color="primary">
                  Velocidade: {result.accMaxSpeedAmount} <br />
                  Hodômetro: {result.accMaxHodometerAmount} <br />
                  RPM: {result.accMaxRpmAmount}
                </Typography>
              )}
            />
            {/* Restart do Hodômetro */}
            <CustomExpansionPanel title="Restart do Hodômetro" shouldRender={result.hodometerRestartAmount >= 0} 
              render={() => (
                <Typography color="primary">
                  Quantidade: {result.hodometerRestartAmount}
                </Typography>
              )}
            />
            {/* Restart do PCount */}
            <CustomExpansionPanel title="Restart do PCount" shouldRender={result.packetCounterRestartAmount >= 0} 
              render={() => (
                <Typography color="primary">
                  Quantidade: {result.packetCounterRestartAmount}
                </Typography>
              )}
            />
            {/* Ignição On/Off */}
            <CustomExpansionPanel title="Coordenadas com Ignição On/Off" shouldRender={result.ignitionOffAmount >= 0} 
              render={() => (
                <Typography color="primary">
                  Quantidade On: {result.ignitionOnAmount} <br />
                  Quantidade Off: {result.ignitionOffAmount}
                </Typography>
              )}
            />
            {/* Coordenadas em Sombra */}
            <CustomExpansionPanel title="Coordenadas em Sombra" shouldRender={result.coordinateInShadowAmount >= 0} 
              render={() => (
                <Typography color="primary">
                  Quantidade: {result.coordinateInShadowAmount}
                </Typography>
              )}
            />
            {/* Veículo do Trix */}
            <CustomExpansionPanel title="Veículo" shouldRender={result.vehicle} 
              render={() => (
                <Typography color="primary">
                  Código: {result.vehicle.code} <br />
                  Placa: {result.vehicle.plate} <br />
                  Organização: {result.vehicle.organization.name} <br />
                  Marca: {result.vehicle.brand} <br />
                  Modelo: {result.vehicle.model} <br />
                </Typography>
              )}
            />
            {/* Tipo do Veículo do Trix */}
            <CustomExpansionPanel title="Tipo do Veículo" shouldRender={result.vehicleType} 
              render={() => (
                <Typography color="primary">
                  Código: {result.vehicleType.code} <br />
                  Descrição: {result.vehicleType.description} <br />
                </Typography>
              )}
            />
            {/* Equipamento do Trix */}
            <CustomExpansionPanel title="Equipamento" shouldRender={result.equipment} 
              render={() => (
                <Typography color="primary">
                  Serial: {result.equipment.serial} <br />
                  Model: {result.equipment.model} <br />
                  Perfil: {result.equipment.profile ? result.equipment.profile.name : null}
                </Typography>
              )}
            />
            {/* Data da Última Manutenção */}
            <CustomExpansionPanel title="Última Manutenção" shouldRender={result.lastMaintenance} 
              render={() => (
                <Typography color="primary">
                  Data: {new Date(result.lastMaintenance).toLocaleDateString('pt')}
                </Typography>
              )}
            />
            {/* Manutenções Agendadas */}
            <CustomExpansionPanel title="Manutenções Agendadas" shouldRender={result.pendingJiraIssues && result.pendingJiraIssues.length > 0} 
              render={() => (
                <Typography color="primary">
                  {result.pendingJiraIssues.join(', ')}
                </Typography>
              )}
            />
            {/* Tempo de Ignição On e Off (de milli para min) */}
            <CustomExpansionPanel title="Tempo de Ignição On/Off" shouldRender={true} 
              render={() => (
                <Typography color="primary">
                  On: {((result.ignitionOnTimeAmount + result.secondaryIgnitionOnTime || result.ignitionOnTimeAmount) / 1000 / 60).toFixed(2)} min <br />
                  Off: {((result.ignitionOffTimeAmount + result.secondaryIgnitionOffTime || result.ignitionOffTimeAmount)  / 1000 / 60).toFixed(2)} min
                </Typography>
              )}
            />
            {/* Tempo CAN On e Off (de milli para min) */}
            <CustomExpansionPanel title="Tempo CAN" shouldRender={true} 
              render={() => (
                <Typography color="primary">
                  Com: {((result.canTimeAmount + result.secondaryCanTimeAmount || result.canTimeAmount) / 1000 / 60).toFixed(2)} min <br />
                  Sem: {((result.noCanTimeAmount + result.secondaryNoCanTimeAmount || result.noCanTimeAmount) / 1000 / 60).toFixed(2)} min
                </Typography>
              )}
            />
          </ExpansionStyleContext.Provider>
        </Dialog>}
      </div>
    );
  }
}

export default withStyles(styles)(ResultList);


// WEBPACK FOOTER //
// ./src/main/components/ResultList.jsx